import { userAxios } from '../../index'
import { withAllDataDates } from '@/core/utils/dashboardDates'

/** Contrato §10: memberships/dashboard usa `Y-m-d`. */
const membershipDashboard = async data => {
  try {
    return await userAxios
      .post(`insurance/memberships/dashboard`, withAllDataDates(data))
      .then(res => res.data)
  } catch (error) {
    console.log(error)
  }
}

export default {
  membershipDashboard,
}
